
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, Lazy } from "swiper";
require("swiper/swiper.less");
require("swiper/components/lazy/lazy.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Autoplay, Lazy]);
export default defineComponent({
  components: {
    slideInfo,
    ...SWIPER_COMPONENTS,
  },

  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      swiperList: [
        { title: "1面", desc: "个人形象不过关不要#穿着打扮邋遢或过度的不要#沟通能力不过关的不要", img: 'https://mm2015.mamalaile.com.cn/b658fc53223af44098c5ef32f11464a5.jpg' },
        { title: "2查", desc: "三证审查不达标的不要#家庭背景调查不过关的不要#年龄、学历、历史工作审查不过关不要", img: 'https://mm2015.mamalaile.com.cn/cbcef8f6a256a45c6c2fa639e55c2370.jpg' },
        { title: "3考", desc: "理论考试不过关的不要#实操考试不过关的不要#心理素质、抗压能力不过关的不要", img: 'https://mm2015.mamalaile.com.cn/354566423daf9ba5b4833b302daf6ec5.jpg' },
        { title: "4访", desc: "前雇主访谈不过关的不要#同行调查口碑不好的不要", img: 'https://mm2015.mamalaile.com.cn/48d0751b48ca60e7f9c573e65904c501.jpg' },
        { title: "5训", desc: "参加妈妈来了岗前培训#接受统一的规范要求#培训过程表现不合格淘汰", img: 'https://mm2015.mamalaile.com.cn/5f2abe6ca52f370ab13ea41d43b43ec1.jpg' },
        { title: "6评", desc: "场景模拟评审#专家委员会评审#妈妈评审团评审", img: 'https://mm2015.mamalaile.com.cn/467ff7af09bdbacf28b4f5a844daa9d2.jpg' },
      ],
      decorateList: [
        { position: 'bottom-left', url: require('/src/assets/images/home_pic2_bg@2x.png'), width: 28.07 },
      ]
    };
  },
});
